<script>
export default {
  name: 'icon-text-delete',
  props: {
    color: {
      default: () => {
        return 'white'
      },
      type: String,
    },
  },
}
</script>

<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 36 36">
  <g id="グループ_12508" data-name="グループ 12508" transform="translate(-210 -561)">
    <g id="Ellipse_34" data-name="Ellipse 34" transform="translate(210 561)" fill="#fff" stroke="#dedede" stroke-width="1">
      <circle cx="18" cy="18" r="18" stroke="none"/>
      <circle cx="18" cy="18" r="17.5" fill="none"/>
    </g>
    <path id="合体_217" data-name="合体 217" d="M3.644,20a2.336,2.336,0,0,1-2.429-2.219V4.446H15.786V17.781A2.34,2.34,0,0,1,13.356,20Zm8.3-3.207H13.4v-10H11.947Zm-4.179,0H9.225v-10H7.768Zm-4.172,0H5.053v-10H3.6ZM1.215,3.331A1.169,1.169,0,0,1,0,2.223,1.172,1.172,0,0,1,1.215,1.112H4.248L5.463,0h6.074l1.208,1.112h3.041A1.171,1.171,0,0,1,17,2.223a1.169,1.169,0,0,1-1.214,1.108Z" transform="translate(219 569)" fill="#00a5ee"/>
  </g>
</svg>
</template>
